import React from 'react'
import { BatteryProviderContextProps } from 'src/Libs/batteries/providers/types'

export const BatteryProviderContext = React.createContext<BatteryProviderContextProps | undefined>(undefined)
